import PicNewMainDienAnh1 from '../../img/News/41349f4ae77621aa818a599b16d3604a.png';
import PicNewMainDienAnh2 from '../../img/News/truy-cung-giet-tan-cuoc-tai-ngo-cua-hai-ong-hoang-phong-ve-xu-han-15966122361852.png';
import PicNewMainReview1 from '../../img/News/review-tan-tich-quy-am-relic-ba-the-he-va-moi-lien-ket-15965255784224.png';
import PicNewMainReview2 from '../../img/News/review-dinh-thu-oan-khuat-ghost-of-war-15965120886610.png';


export const dataMainDienAnh = [
    {
        hinhAnh: PicNewMainDienAnh1,
        title: "[ANTEBELLUM] - 4 lý do không thể bỏ lỡ siêu phẩm kinh dị Antebellum: Bẫy Thực Tại Kinh Hoàng",
        content: `Không đi theo lối mòn máu me, hù dọa mà đầu tư khai thác những mảng tối của xã hội trên nền một câu chuyện kinh dị, có sự tham gia của nhà sản xuất đã làm nên thành công của loạt tác phẩm ấn tượng “Get Out”, “Us” hay “BlacKkKlansman”,
        và còn nhiều lý do khác khiến người yêu phim không thể bỏ lỡ Ante`
    },
    {
        hinhAnh: PicNewMainDienAnh2,
        title: ` Ác Quỷ Đối Đầu soán ngôi Peninsula, trở thành phim đứng đầu doanh thu tại Hàn Quốc mùa dịch`,
        content: `Vượt mặt Peninsula, Ác Quỷ Đối Đầu trở thành phim ăn khách nhất mùa hè 2020 tại Hàn Quốc. Chỉ sau 12 ngày, Ác Quỷ Đối Đầu chạm điểm hoà vốn với 3.5 triệu lượt xem. Ác Quỷ Đối Đầu giữ vững vị trí top 1 doanh thu 2 tuần liên
        tiếp tại quê nhà Hàn Quốc.
    `
    }
]
export const dataMainReview=[
    {
        hinhAnh: PicNewMainReview1,
        title: "[ANTEBELLUM] - 4 lý do không thể bỏ lỡ siêu phẩm kinh dị Antebellum: Bẫy Thực Tại Kinh Hoàng",
        content: `Không đi theo lối mòn máu me, hù dọa mà đầu tư khai thác những mảng tối của xã hội trên nền một câu chuyện kinh dị, có sự tham gia của nhà sản xuất đã làm nên thành công của loạt tác phẩm ấn tượng “Get Out”, “Us” hay “BlacKkKlansman”,
        và còn nhiều lý do khác khiến người yêu phim không thể bỏ lỡ Ante`
    },
    {
        hinhAnh: PicNewMainReview2,
        title: ` Ác Quỷ Đối Đầu soán ngôi Peninsula, trở thành phim đứng đầu doanh thu tại Hàn Quốc mùa dịch`,
        content: `Vượt mặt Peninsula, Ác Quỷ Đối Đầu trở thành phim ăn khách nhất mùa hè 2020 tại Hàn Quốc. Chỉ sau 12 ngày, Ác Quỷ Đối Đầu chạm điểm hoà vốn với 3.5 triệu lượt xem. Ác Quỷ Đối Đầu giữ vững vị trí top 1 doanh thu 2 tuần liên
        tiếp tại quê nhà Hàn Quốc.
    `
    }
]
export const dataMainKhuyenMai=[
    {
        hinhAnh: PicNewMainReview1,
        title: "[ANTEBELLUM] - 4 lý do không thể bỏ lỡ siêu phẩm kinh dị Antebellum: Bẫy Thực Tại Kinh Hoàng",
        content: `Không đi theo lối mòn máu me, hù dọa mà đầu tư khai thác những mảng tối của xã hội trên nền một câu chuyện kinh dị, có sự tham gia của nhà sản xuất đã làm nên thành công của loạt tác phẩm ấn tượng “Get Out”, “Us” hay “BlacKkKlansman”,
        và còn nhiều lý do khác khiến người yêu phim không thể bỏ lỡ Ante`
    },
    {
        hinhAnh: PicNewMainReview2,
        title: ` Ác Quỷ Đối Đầu soán ngôi Peninsula, trở thành phim đứng đầu doanh thu tại Hàn Quốc mùa dịch`,
        content: `Vượt mặt Peninsula, Ác Quỷ Đối Đầu trở thành phim ăn khách nhất mùa hè 2020 tại Hàn Quốc. Chỉ sau 12 ngày, Ác Quỷ Đối Đầu chạm điểm hoà vốn với 3.5 triệu lượt xem. Ác Quỷ Đối Đầu giữ vững vị trí top 1 doanh thu 2 tuần liên
        tiếp tại quê nhà Hàn Quốc.
    `
    }
]